import classNames from 'classnames/bind';

import styles from './T03_quality.module.scss';
import PageTitle from '../../components/shared/PageTitle';
import icon01 from '../../assets/images/brand/quality/icon-01.png';
import icon02 from '../../assets/images/brand/quality/icon-02.png';
import icon03 from '../../assets/images/brand/quality/icon-03.png';
import icon04 from '../../assets/images/brand/quality/icon-04.png';
import icon05 from '../../assets/images/brand/quality/icon-05.png';
import cert01 from '../../assets/images/brand/quality/cert-01.jpg';
import cert02 from '../../assets/images/brand/quality/cert-02.jpg';
import cert03 from '../../assets/images/brand/quality/cert-03.jpg';
import cert04 from '../../assets/images/brand/quality/cert-04.jpg';

const cx = classNames.bind(styles);

const Quality = () => {
  return (
    <div className={cx('container')}>
      <PageTitle title="철저한 품질 관리" />
      <div className={cx(['section', 'top'])}>
        <div className={cx('limiter')}>
          <h3>5개의 필터를 거친 정수 사용 및 매일 수질 검사</h3>
          <h4>풀무원샘물 검사 항목</h4>
          <ul className={cx('list')}>
            <li>
              <img src={icon01} alt="" />
              <p>
                매일 맛, 냄새, 탁도,
                <br /> 색도, 수소이온농도 검사
              </p>
            </li>
            <li>
              <img src={icon02} alt="" />
              <p>
                매주 1회 이상
                <br /> 미생물 검사
              </p>
            </li>
            <li>
              <img src={icon03} alt="" />
              <p>
                매분기 먹는 물
                <br /> 수질 기준 항목 검사
              </p>
            </li>
            <li>
              <img src={icon04} alt="" />
              <p>
                매년 2회
                <br /> 환경 호르몬 검사
              </p>
            </li>
            <li>
              <img src={icon05} alt="" />
              <p>
                매년 1회
                <br /> 방사능 검사
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className={cx(['section', 'bottom'])}>
        <div className={cx('limiter')}>
          <h3>국제 인증으로 검증한 품질과 안전</h3>
          <ul className={cx('list')}>
            <li>
              <h4>식품안전</h4>
              <img src={cert01} alt="식품안전" />
              <p>
                Food Safety <span className={cx('point')}>FSSC 22000</span>
              </p>
            </li>
            <li>
              <h4>안전</h4>
              <img src={cert02} alt="안전" />
              <p>
                Safety &amp; Health <span className={cx('point')}>ISO 45001</span>
              </p>
            </li>
            <li>
              <h4>품질</h4>
              <img src={cert03} alt="품질" />
              <p>
                Quality <span className={cx('point')}>ISO 9001</span>
              </p>
            </li>
            <li>
              <h4>환경</h4>
              <img src={cert04} alt="환경" />
              <p>
                Environment <span className={cx('point')}>ISO 14001</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Quality;
